import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';
import { notificationTypes } from '../../../constants';
import { showNotification } from '../Notification/Notification';

import style from './TextEditor.module.scss';


export const TextEditor = ({ id, value, onChange, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <div className={ style.wrapper }>
      <ReactQuill
        id={ id }
        value={ value }
        theme="snow"
        modules={{
            toolbar: [
              [ { 'size': [ 'small', false, 'large', 'huge' ] } ],
           //   [ { 'font': [] } ],
              [ { 'align': [] } ],
              [ 'bold', 'italic', 'underline', 'strike' ],
              [ { 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' } ],
              [ { 'color': [] }, { 'background': [] } ],
              [ 'link', 'code-block', 'image' ], // image',
              [ { 'direction': 'rtl' }, { 'direction': 'ltr' } ],
              [ 'clean' ]
            ]
        }}
        formats={ [
            'header', 'background', 'color', 'font',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent', 'size', 'align', 'direction',
            'link', 'image', 'code-block'
        ] }
        onChange={ v => {
       // const size = Buffer.byteLength(v, 'utf8') / 1000000;
       const size = new TextEncoder().encode(v).length / 1000000;
        if (size > 5) {
          showNotification({
            type: notificationTypes.ERROR,
            title: t('ERR.sizeIssue') });
        } else {
          onChange(v);
        }
        } }
        { ...props }
      />
    </div>

  );
};


